import React, { Component } from 'react';
import { connect } from 'react-redux';
import {createBrowserHistory} from 'history';
import './App.css';
import Layout from './components/Shared/Layout';
import Login from './components/Authentication/login';
import SignUp from './components/Authentication/signup';
import ForgotPassword from './components/Authentication/forgotpassword';
import NotFound from './components/Authentication/404';
import InternalServer from './components/Authentication/500';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import HomePage from './components/university/LandingPage/HomePage';
import LegalAid from './components/university/LandingPage/Subsections/LegalAid';
import OurHistory from './components/university/LandingPage/Subsections/OurHistory';
import OurAim from './components/university/LandingPage/Subsections/OurAim';
import Profile from './components/university/LandingPage/Subsections/Profile';
import Management from './components/university/LandingPage/Subsections/Management';
import Activities from './components/university/LandingPage/Subsections/Activities';

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			closeRightbarClass: "close_rightbar"
		};
	}
	UNSAFE_componentWillMount() {
		const ww = document.body.clientWidth;
		if (ww < 1530) {
			this.setState({ closeRightbarClass: "close_rightbar" })
		} else if (ww >= 1531) {
			this.setState({ closeRightbarClass: "" })
		};
	}
	
	render() {
		const { closeRightbarClass } = this.state
		const { isBoxLayout, gradientColor, darkMode, darkSidebar, rtl,
			toggleLeftBar, themeColor, fontType, iconColor } = this.props
		const history = createBrowserHistory();
		return (
			<div
				ref={leftSidebar => {
					this.leftSidebar = leftSidebar;
				}}
				className={`${isBoxLayout ? "boxlayout " : ""}${darkSidebar ? "sidebar_dark " : ""}${gradientColor ? "gradient " : ""}${iconColor ? "iconcolor " : ""}${darkMode ? "dark-mode " : ""}${toggleLeftBar ? "offcanvas-active " : ""} right_tb_toggle ${rtl ? "rtl " : ""}${fontType} ${closeRightbarClass} theme-${themeColor}`}>
				<Router history={history}>
					<Switch>
						<Route exact path="/login" component={Login} />
						<Route exact path="/home" component={HomePage} />
						<Route exact path="/legalaid" component={LegalAid} />
						<Route exact path="/ourHistory" component={OurHistory} />
						<Route exact path="/ourAim" component={OurAim} />
						<Route exact path="/profile" component={Profile} />
						<Route exact path="/management" component={Management} />
						<Route exact path="/activities" component={Activities} />
						<Route path="/" component={Layout} />
						<Route exact path="/signup" component={SignUp} />
						<Route exact path="/forgotpassword" component={ForgotPassword} />
						{/* <Route path="*" component={NotFound} /> */}
						<Route exact path="/internalserver" component={InternalServer} />
					</Switch>
				</Router>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	toggleLeftBar: state.settings.isToggleLeftBar,
	themeColor: state.settings.themeColor,
	darkMode: state.settings.isDarkMode,
	darkSidebar: state.settings.isDarkSidebar,
	iconColor: state.settings.isIconColor,
	gradientColor: state.settings.isGradientColor,
	isBoxLayout: state.settings.isBoxLayout,
	rtl: state.settings.isRtl,
	fontType: state.settings.isFont
})

const mapDispatchToProps = dispatch => ({
})
export default connect(mapStateToProps, mapDispatchToProps)(App)